import dateToUTC from "./dateToUTC";
import getEndOfMonth from "./getEndOfMonth";

const getEndOfMonthUTC = (month: number, year: number) =>
  dateToUTC(getEndOfMonth(month, year));

export default getEndOfMonthUTC;
